import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import Cookies from 'js-cookie';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CounselService {
  private api = inject(ApiService);

  getOne(id: number | string): Promise<any> {
    return this.api.get(`/counsel/${id}`);
  }

  async readUploadState(id: number | string): Promise<any> {
    const res = await firstValueFrom(this.api.getRaw<any>(`/counsel/${id}`));
    if (res?.success !== true || !res.result || String(res.result.id) !== String(id)) throw new Error('画像の保存状態を取得できませんでした');
    return res.result;
  }

  getTrainingProgramList(): Promise<any> {
    return this.api.get('/training');
  }

  async getTrainingPdf(id: number | string): Promise<any> {
    try {
      const res = await firstValueFrom(this.api.getRaw<any>(`/training/pdf/${id}`));
      return res?.result ?? null;
    } catch (err: any) {
      if (err?.status !== 401) this.api.getRouter().navigate(['/error']);
      throw err;
    }
  }

  async uploadPicture(id: number | string, pictureId: number | string, fileData: FormData): Promise<any> {
    const csrfToken = Cookies.get('csrf_token') ?? '';
    try {
      const res = await firstValueFrom(
        this.api.getHttp().post<any>(
          `${this.api.base}/counsel/${id}/picture/${pictureId}`,
          fileData,
          { headers: new HttpHeaders({ 'X-CSRF-Token': csrfToken }) }
        )
      );
      if (res?.success !== true) throw new Error('画像の保存を確認できませんでした');
      return res.result;
    } catch (err: any) {
      throw err;
    }
  }
}
